import React from 'react';
import { translate } from 'react-i18next';

import styles from './TableButton.module.scss';

export type TableButtonProps = {
  title?: string,
  disabled?: boolean,
  iconHref?: string,
  label: string,
  onClick?: () => void,
};

@translate()
export default class TableButton extends React.Component<TableButtonProps> {
  render() {
    const { onClick, disabled, title, t, label, iconHref } = this.props;

    return (
      <div className={styles['manage-button']}>
        <a to="javascript:;" onClick={onClick} className={disabled ? styles['is-disabled'] : ''}>
          {title && (
            <h3 className={`${styles.title}`} title={title}>
              {title}
            </h3>
          )}
          <span className={styles.button}>
            <svg>
              <use xlinkHref={iconHref} />
            </svg>
            {t(label)}
          </span>
        </a>
      </div>
    );
  }
}
